export default function withoutTrailingSlash(url: string) {
    return url.replace(/\/$/, '');
}
